import { createSlice } from '@reduxjs/toolkit';

const discountSlice = createSlice({
  name: 'discount',
  initialState: {
    pendingApprovalRequestId: null,
    pendingApprovalDiscountName: '',
    pendingApprovalLevel: null, // 'bill' | 'line_item'
    pendingOrderId: null,       // order that went on_hold — survives clearOrder()
    // In-flight OTP cycle for pendingApprovalRequestId, if any. Lives here (not
    // component state) because DiscountApprovalModal (starts it) and
    // ApprovalBanner (may pick it back up after a hand-off) are siblings, not
    // parent/child — this is the one piece of OTP state that has to survive
    // that hand-off. expiresAt is a client-computed timestamp (the API
    // doesn't return one). NOT persisted to localStorage (see Dashboard.js) —
    // a refresh mid-cycle just means starting a fresh cycle, same as before.
    otpCycle: null, // { id, cycleNumber, recipients, expiresAt } | null
    // True the instant a discount needs approval, while DiscountApprovalModal
    // is still open handling it (cart untouched). ApprovalBanner.js stays
    // hidden while this is true — otherwise it'd render behind the modal
    // showing the same "awaiting approval" state redundantly. Goes false the
    // moment the cashier hands off (Continue browsing / closes the modal), at
    // which point the banner takes over. Persisted to localStorage alongside
    // the other pendingApproval fields (Dashboard.js) so a page refresh
    // restores into the SAME surface it was showing before, not always the
    // modal.
    awaitingInline: false,
  },
  reducers: {
    setPendingApproval: (state, { payload }) => {
      state.pendingApprovalRequestId = payload.requestId;
      state.pendingApprovalDiscountName = payload.discountName || '';
      state.pendingApprovalLevel = payload.level || null;
      state.pendingOrderId = payload.orderId || null;
      state.otpCycle = null;
      state.awaitingInline = true;
    },
    clearPendingApproval: (state) => {
      state.pendingApprovalRequestId = null;
      state.pendingApprovalDiscountName = '';
      state.pendingApprovalLevel = null;
      state.pendingOrderId = null;
      state.otpCycle = null;
      state.awaitingInline = false;
    },
    handOffPendingApproval: (state) => {
      state.awaitingInline = false;
    },
    setOtpCycle: (state, { payload }) => {
      state.otpCycle = payload;
    },
    clearOtpCycle: (state) => {
      state.otpCycle = null;
    },
  },
});

export const {
  setPendingApproval, clearPendingApproval, handOffPendingApproval, setOtpCycle, clearOtpCycle,
} = discountSlice.actions;
export default discountSlice.reducer;
